import { AI_TOOLS } from '@constants';
import { getToolAdvancedSettingsFields } from '@utils/advancedSettings';
import React from 'react';

const isValidValue = (value) => {
  return !!value && value !== '' && value.length > 0;
};

export const SettingsInput = ({ value, onChange }) => {
  const [settings] = React.useState(getToolAdvancedSettingsFields(AI_TOOLS.AGENT_FLOW).sort());

  const alertInvalidValue = (message) => {
    // alert(message);
  };

  React.useEffect(() => {
    if (!settings.includes(value) && isValidValue(value)) {
      alertInvalidValue(`Invalid Setting reference found: ${value}`);
      console.log(`Invalid Setting reference found: ${value}`, { settings, value });
      onChange({ target: { value: '' } });
    }
  }, [settings, value]);

  return (
    <select value={value} onChange={onChange}>
      <option value={''}>Please select...</option>
      {settings.map((id) => (
        <option key={id} value={id}>
          {id}
        </option>
      ))}
    </select>
  );
};
